import * as React from 'react';
import System from 'src/helper/system';

const NonLoginSignInButton = (props) => {
    const getLoginButtonText = () => {
        if (props.isAuthAccLess !== undefined &&
            props.isAuthAccLess === true) {
            return 'Request for an ';
        }
        if (props.isGuestAccess !== undefined && 
            props.isGuestAccess === true) {
            return 'sign in to see'
        }
        if (props.best_selling) {
            return 'sign in'
        }
        return 'sign in to see your'
    }
    return (
        <div className="text-center py-3">
            <button className={((props.compare_product !== undefined && props.compare_product === true) ||
                (props.isGuestAccess !== undefined && props.isGuestAccess === true)) ? "bs5 btn btn-secondary btn-sm text-wrap" : (props.best_selling ? "bs5 btn btn-primary w-100" : "bs5 btn btn-secondary w295")}
                onClick={() => window.location.href = System.getLoginPageUrl(props.isAuthAccLess)}>{getLoginButtonText()}
                
                {props?.best_selling ? '' : (props.isGuestAccess !== undefined && props.isGuestAccess === true ? ' ' : ' ' + System.siteName() + ' ')}
                {props?.best_selling ? '' : (props.isAuthAccLess !== undefined && props.isAuthAccLess === true ? 'account' : 'price')}
            </button>
        </div>
    );
}

export default NonLoginSignInButton;